import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import WebhookForm from "./WebhookForm";
import useWebhookForm from "./useWebhookForm";

export default WebhookFormDialog;

const webhookFormDialogAddModeProps = {
  title: "Add Webhook",
  primaryActionLabel: "Add",
};

const webhookFormDialogEditModeProps = {
  title: "Edit Webhook",
  primaryActionLabel: "Save",
};

function WebhookFormDialog(props) {
  const { state, onWebhookAdd, onWebhookUpdate, onClose } = props;

  const { formState, updateFormState, errors, validate } = useWebhookForm(
    state.webhook ?? {},
  );

  const isModeAdd = state.mode === "add";

  const webhookFormDialogProps = isModeAdd
    ? webhookFormDialogAddModeProps
    : webhookFormDialogEditModeProps;

  const handlePrimary = () => {
    console.log({formState, state})

    if (!validate()) {
      return;
    }

    if (isModeAdd) {
      onWebhookAdd(formState);
      onClose();
      return;
    } else {
      onWebhookUpdate(formState, state.webhookIdx);
    }

    onClose();
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>{webhookFormDialogProps.title}</DialogTitle>
      <DialogBody>
        <WebhookForm
          formState={formState}
          updateFormState={updateFormState}
          errors={errors}
        />
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button onClick={handlePrimary}>
          {webhookFormDialogProps.primaryActionLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
